export const repeatRequest = ($injector, httpConfig, delay) => {
    const $timeout = $injector.get('$timeout');
    return $timeout(() => {
        const $http = $injector.get('$http');
        return $http(httpConfig);
    }, delay);
};
